export default __webpack_public_path__ + "static/media/logoIcon.ba4db533.png";